// SAMPLE DATA, obviously fake on purpose, shown ONLY while developing. The live
// site shows an honest "being prepared" message until the real directory is
// connected (see DIRECTORY_LIVE in src/config.ts and BACKEND-LINKS.md).
//
// The shapes match what the public feed will return from the portal's database:
// institutes (code, name, city, district, state) and exam centres (name, city,
// district, state). Never contact persons, phone numbers or e-mail addresses.

export interface DirectoryInstitute { code: string; name: string; town: string; district: string; state: string }
export interface DirectoryCentre { name: string; town: string; district: string; state: string }

export const MOCK_INSTITUTES: DirectoryInstitute[] = [
  { code: 'MAH/00', name: 'Sample Technical Institute A', town: 'Mumbai', district: 'Mumbai Suburban', state: 'Maharashtra' },
  { code: 'MAH/01', name: 'Sample Technical Institute B', town: 'Pune', district: 'Pune', state: 'Maharashtra' },
  { code: 'GOA/00', name: 'Sample Vocational Centre C', town: 'Panaji', district: 'North Goa', state: 'Goa' },
  { code: 'KAR/00', name: 'Sample Computer Institute D', town: 'Belagavi', district: 'Belagavi', state: 'Karnataka' },
  { code: 'GUJ/00', name: 'Sample Training Institute E', town: 'Surat', district: 'Surat', state: 'Gujarat' },
];

export const MOCK_CENTRES: DirectoryCentre[] = [
  { name: 'Sample Exam Centre A', town: 'Bhandup', district: 'Mumbai Suburban', state: 'Maharashtra' },
  { name: 'Sample Exam Centre B', town: 'Pune', district: 'Pune', state: 'Maharashtra' },
  { name: 'Sample Exam Centre C', town: 'Panaji', district: 'North Goa', state: 'Goa' },
  { name: 'Sample Exam Centre D', town: 'Belagavi', district: 'Belagavi', state: 'Karnataka' },
];
